module.exports = __webpack_public_path__ + "img/logo-presse-dnl_200x200.59668e9a.jpg";